import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealsGroupWiseReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/ig/deals/group";

  url1 = environment.serverAPI9 + "/api/dealsUserWiseReport/group";

  url2 = environment.serverAPI9 + "/api/dealsProbability/group";

  url3 = environment.serverAPI9 + "/api/dealsStatusReport/group";

  url4 = environment.serverAPI9 + "/api/dealsSourceReport/group";



  searchDealsUserWiseReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url1}/condition${queryParams}`, requestBody);
  }

  searchDealsProbabilityReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }

  searchDealsStatusReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url3}/condition${queryParams}`, requestBody);
  }

  searchDealsSourceReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url4}/condition${queryParams}`, requestBody);
  }

  downloadDealsGroupWiseReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getDealsGroupWiseReport(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
